import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { qboReconciliationEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { DeadLetterRow } from '@/types/qbo-reconciliation';

interface DeadLetterEnvelope {
  items: DeadLetterRow[];
}

/**
 * Spec §9.7 — Dead-letter queue for the active tenant. Lists every
 * SyncRecord that hit the 6-attempt budget and is awaiting human
 * triage. Polls every 60s so the badge in the page header stays
 * current without thrashing the API.
 */
export function useDeadLetterQueue() {
  return useApiQuery<DeadLetterEnvelope>({
    queryKey: settingsKeys.qboDeadLetter(),
    queryFn: () =>
      apiGet<DeadLetterEnvelope>(operationsClient, qboReconciliationEndpoints.deadLetter()),
    refetchInterval: 60_000,
    staleTime: 30_000,
    showErrorToast: false,
  });
}
